<template>
    <va-create-layout>
        <DebtRecoveryEventItem-form
            :title="title"
            :item="item"
        ></DebtRecoveryEventItem-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
